import {Button, Col, Divider, Row, Space, Spin, Typography} from "antd";
import {HeaderPrintForm, Notification} from "components/common";
import Sign from "components/common/PrintForm/Sign/Sign";
import React, {useEffect, useMemo, useRef, useState} from "react";
import ReactToPrint from "react-to-print";
import {useAppDispatch, useAppSelector} from "redux/hooks";

import {formatDateToString, getAge} from "helper/common";
import {FORMAT_TIME} from "types/enums";
import {infoDetailsProps} from "types/models/infoDetailsProps";
import "./PrintForm.scss";
import refraction from "api/refraction";
import ContentPrint from "./ContentPrint";
import {removeEmpty} from "helper/refraction";
import {setData} from "redux/reducer/pending";
import {InfoItem} from "components/common/PrintForm";
import {formatPhoneNumber} from "helper/format-phone";
import SearchPatientService from "api/searchPatient";

const RefractiveModal = props => {
  const {closeModal, openModal} = props;
  const [loading, setLoading] = useState(false);
  const [newDetail, setNewDetail] = useState<infoDetailsProps>();
  const idPhieu = useAppSelector(e => e.pending.idReceipt);
  const dispatch = useAppDispatch();
  const printRef = useRef<any>();
  const inDetail = useAppSelector(state => state.pending?.inDetail);

  const getDetail = async id => {
    setLoading(true);
    try {
      const res = await SearchPatientService.getDetailReceivedById(id);
      const newRes = removeEmpty(res);
      setNewDetail(newRes);
      // dispatch(setData(newRes));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Lấy dữ liệu không thành công");
    }
  };
  // useEffect(() => {}, [idPhieu]);

  useMemo(() => {
    if (idPhieu !== null || idPhieu) {
      getDetail(idPhieu);
    }
  }, [openModal]);

  const fields1 = [
    {label: "Họ và tên", value: newDetail?.hoTen},
    {
      label: "Ngày sinh - Tuổi",
      value: `${formatDateToString(newDetail?.ngaySinh, FORMAT_TIME.dayFull)}`,
    },
    {
      label: "Giới tính",
      value: newDetail?.gioiTinh == 0 ? "Nam" : "Nữ",
    },
    {label: "Điện thoại", value: formatPhoneNumber(newDetail?.phoneNumber)},
    {label: "Địa chỉ", value: newDetail?.diaChiTongHop},
  ];

  const fields2 = [
    {
      label: "Khám bệnh lúc",
      value: formatDateToString(newDetail?.createdDate, FORMAT_TIME.dateTime),
    },
    {label: "Mã phiếu khám", value: newDetail?.idPhieuKham},
    {label: "Mã bệnh nhân", value: newDetail?.maBenhNhan},
    {label: "Số BHYT", value: newDetail?.baoHiem},
  ];

  const onPrint = async () => {
    window.print();
  };

  return (
    <div className="print-form-khuc-xa">
      <div className="refraction-print" ref={printRef}>
        <table>
          <thead>
            <tr style={{height: "10px"}}></tr>
            <HeaderPrintForm></HeaderPrintForm>
            <tr style={{height: "30px"}}></tr>
          </thead>
          <tbody>
            <Spin spinning={loading}>
              <tr>
                <div>
                  <InfoItem
                    fields1={fields1}
                    fields2={fields2}
                    idBenhNhan={newDetail?.maBenhNhan}
                    title={"PHIẾU KẾT QUẢ KHÚC XẠ"}
                    chiefComplaints={newDetail?.chiefComplaints}
                  />

                  <Divider />
                  <div className="container2">
                    {(newDetail?.tienSuGiaDinh ||
                      newDetail?.benhSu ||
                      newDetail?.tienSuBenhToanThan) && (
                      <>
                        <div className="title-name">Tiền sử bệnh</div>
                        <Space direction="vertical">
                          <Row>
                            {newDetail?.benhSu && (
                              <>
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    paddingRight: "5px",
                                  }}
                                >
                                  Bệnh sử:
                                </Typography>
                                <Typography.Text ellipsis={true}>
                                  {newDetail?.benhSu}
                                </Typography.Text>{" "}
                              </>
                            )}
                          </Row>
                          <Row>
                            {newDetail?.tienSuBenhToanThan && (
                              <>
                                {" "}
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    paddingRight: "5px",
                                  }}
                                >
                                  Tiền sử bệnh toàn thân:
                                </Typography>
                                <Typography.Text ellipsis={true}>
                                  {newDetail?.tienSuBenhToanThan}
                                </Typography.Text>
                              </>
                            )}
                          </Row>
                          <Row>
                            {newDetail?.tienSuGiaDinh && (
                              <>
                                {" "}
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    paddingRight: "5px",
                                  }}
                                >
                                  Tiền sử gia đình:
                                </Typography>
                                <Typography.Text ellipsis={true}>
                                  {newDetail?.tienSuGiaDinh}
                                </Typography.Text>
                              </>
                            )}
                          </Row>
                        </Space>
                        <Divider className="custom-divider" />
                      </>
                    )}
                  </div>

                  <div className="container3">
                    <div className="title-name">Khúc xạ</div>
                    <div className="position-eye">
                      <span>Mắt phải</span>
                      <span style={{marginRight: "8px"}}>Mắt trái</span>
                    </div>
                    <ContentPrint detailPhieu={newDetail} />
                  </div>

                  {inDetail ? (
                    <Sign nguoiThucHien={newDetail?.tenBsThucHien ?? ""} />
                  ) : (
                    <Sign
                      nguoiThucHien={newDetail?.tenBsThucHien ?? ""}
                      time={newDetail?.ngayNhapVien}
                    />
                  )}
                </div>
              </tr>
            </Spin>
          </tbody>
          <tfoot>
            <tr style={{height: "2cm"}}></tr>
          </tfoot>
        </table>
      </div>
      <Row justify={"end"} className="footer" gutter={16}>
        <Col>
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
        </Col>
        <ReactToPrint
          trigger={() => {
            return (
              <Button type="primary" onClick={onPrint}>
                In
              </Button>
            );
          }}
          content={() => printRef.current}
          bodyClass="print-form-khuc-xa"
        />
      </Row>
    </div>
  );
};
export default RefractiveModal;
